import { useEffect, useState } from "react";

import { Dialog, Grid, Link, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import sweptBlueLogo from "../../assets/images/sweptBlueLogo.png";
import {
  apiRequest,
  customNavigate,
  formatApiRequestError,
} from "../../helpers";
import DialogActions from "../modals/DialogActions";
import DialogContent from "../modals/DialogContent";
import DialogTitle from "../modals/DialogTitle";

const useStyles = makeStyles()((theme: any) => ({
  backdrop: {
    backgroundColor: theme.palette.background.default,
    textAlign: "center",
    padding: theme.spacing(1),
  },
  container: {
    maxWidth: "450px",
    margin: `${theme.spacing(2)} auto`,
    justifyContent: "center",
  },
  link: {
    color: theme.palette.secondary.main,
  },
  logo: {
    marginTop: theme.spacing(8),
    width: "170px",
  },
  margin: {
    marginTop: theme.spacing(2),
  },
  modalContainer: {
    margin: "auto",
    maxWidth: "703px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

const AcceptInvitePage = () => {
  const { classes } = useStyles();
  const [params] = useSearchParams();

  const id_param = params.get("var1");
  const token = params.get("var2");

  const [companyName, setCompanyName] = useState(" ");
  const [isLoading, setIsLoading] = useState(true);
  const [showInviteApprovalSuccess, setShowInviteApprovalSuccess] =
    useState(false);
  const [showTokenExpiredModal, setShowTokenExpiredModal] = useState(false);

  const abortController = new AbortController();

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: `v2/accept-invite`,
      params: { id: id_param, token: token },
      signal: abortController.signal,
    })
      .then((response: any) => {
        setCompanyName(response.companyName);
        setShowInviteApprovalSuccess(true);
      })
      .catch((error) => {
        setShowTokenExpiredModal(true);
        console.warn(
          "User ID or token is invalid or expired:",
          formatApiRequestError(error)
        );
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(function () {
          customNavigate("/");
        }, 5000);
      });

    return () => {
      abortController.abort();
    };

    // eslint-disable-next-line
  }, [id_param, token]);

  return (
    <>
      {!isLoading && (
        <div className={classes.backdrop}>
          <img src={sweptBlueLogo} alt="Swept" className={classes.logo} />
          <Grid className={classes.container} container>
            {showInviteApprovalSuccess && (
              <>
                <Grid item xs={12}>
                  <Typography variant="h6">
                    Congratulations! <br />
                    Your profile is active in <b>{companyName}</b>. You will be
                    redirected to the sign-in page shortly. Click{" "}
                    <Link href="/">here</Link> if you encounter any issues.
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
        </div>
      )}

      <Dialog
        className={classes.modalContainer}
        fullWidth
        onClose={() => customNavigate("/")}
        open={showTokenExpiredModal}
        PaperProps={{ square: true }}
      >
        <DialogTitle onDismiss={() => customNavigate("/")}>
          Whoops, that's an expired link
        </DialogTitle>
        <DialogContent>
          <Typography>
            For security reasons, invites to join a company expire after 15
            days.
          </Typography>
        </DialogContent>
        <DialogActions
          onDismiss={() => customNavigate("/")}
          closeButtonText={"Okay"}
        />
      </Dialog>
    </>
  );
};

export default AcceptInvitePage;
